import React, {useEffect} from 'react';
import {LanguageProvider, Translation} from "./Translation";
import {LanguageSelect} from "./languageSelect";
import {ThemeProvider} from "./Theme";
import {ThemeSelect} from "./themeSelect";
import {Helmet} from "react-helmet";
import useTheme from "../useHooks/useTheme";

export const STATUS = {
    "unknowned": "unknowend",
    "loading": "loading",
    "loaded": "loaded",
    "complete": "complete",
    "failed": "failed"
}

const Header = () => {

    const {theme, css} = useTheme();

    useEffect( () => {}, [theme])

    return <Helmet>
        <link rel="stylesheet" href={ css() }/>
    </Helmet>
}

export const App = props =>
    <ThemeProvider>
        <LanguageProvider>
            <Translation>
                <Header />
                <LanguageSelect/>
                <ThemeSelect />
                {props.children}
            </Translation>
        </LanguageProvider>
    </ThemeProvider>;